<template>
    <div class="container has-text-left margin_top_2rem">
        <b-table
                v-if="list.length > 0"
                :narrowed="true"
                :striped="true"
                detailed
                detail-key="id"
                :data="list"
        >
            <template slot-scope="props">
                <b-table-column label="Name" field="name">
                    <router-link :to="{path: '/configure/devices/' + props.row['device_id'] + '/endpoints/' + props.row.id}">{{props.row.name}}</router-link>
                </b-table-column>
                <b-table-column label="URL" field="short_url">{{props.row.short_url}}</b-table-column>
                <b-table-column field="delete" numeric>
                    <div @click="handleDeleteEndpoint(props.row.id)">
                        <b-icon type="is-danger" icon="delete" style="cursor: pointer;"></b-icon>
                    </div>
                </b-table-column>
            </template>

            <template slot="detail" slot-scope="props">
                <div>
                    <div>Method: {{props.row.method}}</div>
                    <div>URL: {{props.row.url}}</div>
                    <div v-if="props.row.headers.length > 0">Headers: {{props.row.headers}}</div>
                    <div v-if="props.row.method.toUpperCase() === 'GET'">Replacement: {{props.row.replacement}}</div>
                    <div v-else>Body Param Name: {{props.row.body_param_name}}</div>
                </div>
            </template>
        </b-table>
        <div v-else>No endpoints defined.</div>
    </div>

</template>

<script>
    import {mapActions} from 'vuex';
  import BTable from "buefy/src/components/table/Table";
  import BTableColumn from "buefy/src/components/table/TableColumn";

  export default {
    components: {
      BTableColumn,
      BTable},
    name: "endpoint-list",
    props: ['deviceId', 'data'],
    computed: {
      list() {
        return this.data.map(item => {
          return {
            ...item,
            short_url: item.url.slice(0, Math.min(32, item.url.length)) + '...'
          };
        });
      }
    },
    methods: {
      ...mapActions('devices', ['deleteDeviceEndpoint']),
      handleDeleteEndpoint(id) {
        if (confirm('Are you sure ?')) {
          this.deleteDeviceEndpoint({
            deviceId: this.deviceId,
            id: id
          });
        }
      }
    }
  }
</script>

<style scoped>
    .margin_top_2rem {
        margin-top: 2rem;
    }
</style>